function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon ionic-md-close",
  d: "M25 2.5L22.5 0l-10 10-10-10L0 2.5l10 10-10 10L2.5 25l10-10 10 10 2.5-2.5-10-10z",
  fill: "#002f4d"
});
var SvgBasicCloseIcon = function SvgBasicCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25"
  }, props), _ref);
};
export default SvgBasicCloseIcon;